import ThresholdFilter from "@/components/ssa_components/displayPane/thresholdFilter.vue";
import { App as Application } from "vue";
import Accordion from "../components/additional_components/accordion.vue";
import Card from "../components/additional_components/card.vue";
import Chip from "../components/additional_components/chip.vue";
import DataUsage from "../components/additional_components/data-usage.vue";
import Dialog from "../components/additional_components/dialog.vue";
import Layout from "../components/additional_components/layout.vue";
import Menu from "../components/additional_components/menu.vue";
import Preloader from "../components/additional_components/preloader.vue";
import Progress from "../components/additional_components/progress.vue";
import Spinner from "../components/additional_components/spinner.vue";
import Status from "../components/additional_components/status.vue";
import TabItem from "../components/additional_components/tab-item.vue";
import TabItems from "../components/additional_components/tab-items.vue";
import Tab from "../components/additional_components/tab.vue";
import Table from "../components/additional_components/table.vue";
import Tabs from "../components/additional_components/tabs.vue";
import Toast from "../components/additional_components/toast.vue";
import Tooltip from "../components/additional_components/tooltip.vue";
import DataImport from "../components/importDialogs/import.vue";
import ButtonToggle from "../components/inputs/button-toggle.vue";
import Button from "../components/inputs/button.vue";
import Checkbox from "../components/inputs/checkbox.vue";
import DateTimePicker from "../components/inputs/datetime-picker.vue";
import RadioGroup from "../components/inputs/radio-group.vue";
import Radio from "../components/inputs/radio.vue";
import Select from "../components/inputs/select.vue";
import Slider from "../components/inputs/slider.vue";
import Switch from "../components/inputs/switch.vue";
import Input from "../components/inputs/text-input.vue";
import TextArea from "../components/inputs/textarea.vue";
import Sidebar from "../components/navigation/sidebar.vue";
import ColorBySelector from "../components/ssa_components/displayPane/colorBySelector.vue";
import Slicing from "../components/ssa_components/displayPane/slicing.vue";

export default function registerComponents(app: Application) {
	app.component("imdex-btn-toggle", ButtonToggle);
	app.component("imdex-layout", Layout);
	app.component("imdex-checkbox", Checkbox);
	app.component("imdex-text-field", Input);
	app.component("imdex-btn", Button);
	app.component("imdex-dialog", Dialog);
	app.component("imdex-radio-group", RadioGroup);
	app.component("imdex-radio", Radio);
	app.component("imdex-select", Select);
	app.component("imdex-textarea", TextArea);
	app.component("imdex-slider", Slider);
	app.component("imdex-tabs", Tabs);
	app.component("imdex-tab", Tab);
	app.component("imdex-tab-item", TabItem);
	app.component("imdex-tab-items", TabItems);
	app.component("imdex-accordion", Accordion);
	app.component("imdex-card", Card);
	app.component("imdex-chip", Chip);
	app.component("imdex-progress", Progress);
	app.component("imdex-sidebar", Sidebar);
	app.component("imdex-status", Status);
	app.component("imdex-preloader", Preloader);
	app.component("imdex-tooltip", Tooltip);
	app.component("imdex-table", Table);
	app.component("imdex-spinner", Spinner);
	app.component("imdex-data-usage", DataUsage);
	app.component("imdex-import", DataImport);
	app.component("imdex-switch", Switch);
	app.component("imdex-toast", Toast);
	app.component("imdex-menu", Menu);
	app.component("imdex-datetime-picker", DateTimePicker);
	app.component("imdex-color-by-selector", ColorBySelector);
	app.component("imdex-slicing", Slicing);
	app.component("imdex-threshold-filter-manager", ThresholdFilter);
}
